import { Component, Vue } from 'vue-property-decorator';
import { getComponentProps } from '@/utils/vueUtils';

import { ShareModuleViewModel } from './ShareModule.types';

import ShareComponent from '@/components/Share/Share.vue';

const ShareModuleProps = Vue.extend({
  props: getComponentProps<ShareModuleViewModel>({
    Url: 'https://d3t9z7c45vc1rg.cloudfront.net/',
    Title: 'Share Report',
    Description: 'Description goes here',
    Hashtags: 'itinerary,travel,lindblad',
    Quote: 'quote goes here - facebook',
    TwitterUser: 'LindbladExp',
  }),
});

@Component({
  components: { ShareComponent },
})
export default class ShareModule extends ShareModuleProps {
  get ShareData() {
    return this.p;
  }
}
